export const assets = {
  logo: './assets/images/logo.png',
  adminIcon: 'assets/images/profile.png',
  placeHolderLogo: 'assets/images/placeholder.png',
  plusIcon:  'assets/images/plus.png',
  sidebarDashboardIcon: 'assets/images/dash.svg',
  viewIcon: 'assets/images/eye.svg',
  edit_icon: 'assets/images/edit_icon.svg',
  deleteIcon: 'assets/images/delete_icon.svg',
  RevenueIcon: 'assets/images/revenue.svg',
  ReveiwIcon: 'assets/images/rating.svg',
  CmsIcon: 'assets/images/cms.svg',
  LogoutIcon: 'assets/images/logout.svg',
  NotificationIcon: 'assets/images/notification.svg',
  searchIcon: 'assets/images/search_icon.svg',
  UsersIcon: 'assets/images/total_user.svg',
  AdIcon: 'assets/images/ad_icon.svg',
  QuestionMark: 'assets/images/reports_icon.svg',
  cameraIcon: 'assets/images/camera_icon.svg',
  revertIcon: 'assets/images/revert.svg',
  dealIcon: 'assets/images/deals.svg',
  settingIcon: 'assets/images/setting.svg',
  bookingIcon: 'assets/images/booking.svg',
  CategoryIcon: 'assets/images/category.svg',
  VoucherIcon: 'assets/images/voucher.svg',
  ReportIcon: 'assets/images/reports.svg',
  listIcon: 'assets/images/list_icon.png',
  icon3: 'assets/images/icon3.svg',
  attachment27: 'assets/images/attachment_27.jpg',
  attachment28: 'assets/images/attachment_28.jpg',
  attachment25: 'assets/images/attachment_25.jpg',
  icon1: 'assets/images/icon1.svg',
  attachment26: 'assets/images/attachment_26.jpg',
  packageIcon: 'assets/images/services.svg',
  serviceIcon: 'assets/images/package.svg',
  icon2: 'assets/images/icon3.svg',

  DealsIcon:'assets/images/deals.svg',
  BookingIcon:'assets/images/booking.svg',
  noDataFound: 'assets/images/Nodat-found.gif',
  AmenitiesIcon:'assets/images/amenities.svg',
  AddPackageIcon:'assets/images/add-package.svg',
  aedicon:'assets/images/aed.svg',
  success_icon: 'assets/images/success_icon.png',
  cancelledIcon: 'assets/images/cancelled.png',
  declinedIcon: 'assets/images/declined.png'
};
